import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";

export default class PhoneInputService{
    static phoneUtil = PhoneNumberUtil.getInstance();

    static setCountryCode(phone: string){
        let callingCode, phoneNumber;
        try {
            let parsedPhone;
            if(phone.startsWith('+')) {
              parsedPhone = this.phoneUtil.parse(phone);
            } else {
              parsedPhone = this.phoneUtil.parse('+' + phone);
            }
            callingCode = '+' + parsedPhone.getCountryCode();
            phoneNumber = parsedPhone.getNationalNumber();
          } catch (e) {
            if(phoneNumber === '' && callingCode !== phone) {
              callingCode = '';
              phoneNumber = phone;
            }
          }
        return{
            callingCode, phoneNumber
        }
    }


}